import { useContext } from 'react';
import { DirectionContext } from '../../../provider/direction/DirectionProvider.mjs';

const useDirection = () => {
  const direction = useContext(DirectionContext);
  return {
    direction,
    isRTL: direction === 'rtl'
  };
};

export { useDirection };
//# sourceMappingURL=useDirection.mjs.map
